import { motion } from "framer-motion";
import { Phone, ArrowRight } from "lucide-react";

export default function Hero({ hero, stats, contact, onQuote }) {
  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={hero.image} alt="Industrial garment manufacturing facility" className="w-full h-full object-cover opacity-40 animate-kenburns" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D0F12]/70 via-[#0D0F12]/85 to-[#0D0F12]" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 pt-20 pb-16 lg:pt-32 lg:pb-24">
        <motion.p
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
          className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]"
          data-testid="hero-eyebrow">
          {hero.eyebrow}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-4 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-none max-w-4xl"
          data-testid="hero-title">
          {hero.title}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-6 max-w-2xl text-base md:text-lg text-slate-300 leading-relaxed"
          data-testid="hero-subtitle">
          {hero.subtitle}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-10 flex flex-wrap gap-4">
          <button data-testid="hero-request-quote-button" onClick={onQuote}
            className="inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04810] text-white font-bold rounded-full px-7 py-3.5 transition-all hover:gap-3 shadow-lg shadow-[#FF5A1F]/25">
            Get a Wholesale Quote <ArrowRight size={18} />
          </button>
          <a data-testid="hero-call-now-button" href={`tel:${contact.phone}`}
            className="inline-flex items-center gap-2 border border-white/25 hover:bg-white/10 text-white font-semibold rounded-full px-7 py-3.5 transition-colors">
            <Phone size={18} /> Call {contact.phone}
          </a>
        </motion.div>
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="hero-stats">
          {stats.map((s, i) => (
            <motion.div key={s.label}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.07 }}
              className="bg-[#161B22]/80 backdrop-blur border border-white/10 rounded-2xl p-6"
              data-testid={`hero-stat-${i}`}>
              <p className="font-heading text-2xl sm:text-3xl font-extrabold text-[#FF5A1F]">{s.value}</p>
              <p className="mt-1 text-sm text-slate-400">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
